import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

import { useNotificationStore } from '@/stores/notification'
import { REVENDAS_MAP } from '@/utils/apiRoutes'
import { useApi } from '@/utils/axios'

import citiesByStates from '@/utils/estados-cidades.json'

export const statusIconColorsPedidos = [
  {
    value: '1',
    label: 'green',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  },
  {
    value: '2',
    label: 'green',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  },
  {
    value: '3',
    label: 'blue',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  },
  {
    value: '4',
    label: 'red',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  },
  {
    value: '5',
    label: 'violet',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png',
  },
]

export const statusIconColorsEnderecos = [
  {
    value: '1',
    label: 'green',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  },
  {
    value: '2',
    label: 'green',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  },
  {
    value: '3',
    label: 'blue',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  },
  {
    value: '4',
    label: 'red',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  },
  {
    value: '5',
    label: 'violet',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png',
  },
  {
    value: '16',
    label: 'yellow',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
  },
  {
    value: '17',
    label: 'violet',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png',
  },
  {
    value: 'S',
    label: 'gold',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-gold.png',
  },
  {
    value: 'N',
    label: 'black',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-black.png',
  },
  {
    value: 'orange',
    label: 'orange',
    link: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
  },
]

export const pedidosOrigens = [
  { value: 0, label: 'Bot Whatsapp' },
  { value: 1, label: 'Telemarketing' },
  { value: 2, label: 'Site PG' },
  { value: 3, label: 'Aplicativo' },
  { value: 4, label: 'Whatsapp' },
  { value: 6, label: 'Entrega do Gás' },
  { value: 7, label: 'Botijão de Gás' },
  { value: 8, label: 'Botijão Vazio' },
  { value: 9, label: 'Comprar gás de cozinha' },
  { value: 10, label: 'Tel Ultra' },
  { value: 11, label: 'Tel Super' },
  { value: 12, label: 'Distribuidores' },
  { value: 13, label: 'Botijão' },
  { value: 14, label: 'Refeito' },
  { value: 15, label: 'Site novo' },
  { value: 16, label: 'Aplicativo novo' },
  { value: 17, label: 'App Apple' },
]

// Opções dos campos da versão 1
export const statusPedidoOptions = [
  { title: 'Todos', value: '' },
  { title: 'Entregue', value: '3' },
  { title: 'Aceito', value: '2' },
  { title: 'Aberto', value: '1' },
  { title: 'Cancel Rev', value: '4' },
  { title: 'Cancel Cli', value: '5' },
]

export const statusAtivoOptions = [
  { title: '', value: '' },
  { title: 'Ativado', value: '1' },
  { title: 'Desativado', value: '0' },
]

export const estadosOptions = [
  { title: '', value: '' },
  { title: 'AC - Acre', value: 'AC' },
  { title: 'AL - Alagoas', value: 'AL' },
  { title: 'AP - Amapá', value: 'AP' },
  { title: 'AM - Amazonas', value: 'AM' },
  { title: 'BA - Bahia', value: 'BA' },
  { title: 'CE - Ceará', value: 'CE' },
  { title: 'DF - Distrito Federal', value: 'DF' },
  { title: 'ES - Espírito Santo', value: 'ES' },
  { title: 'GO - Goiás', value: 'GO' },
  { title: 'MA - Maranhão', value: 'MA' },
  { title: 'MT - Mato Grosso', value: 'MT' },
  { title: 'MS - Mato Grosso do Sul', value: 'MS' },
  { title: 'MG - Minas Gerais', value: 'MG' },
  { title: 'PA - Pará', value: 'PA' },
  { title: 'PB - Paraíba', value: 'PB' },
  { title: 'PR - Paraná', value: 'PR' },
  { title: 'PE - Pernambuco', value: 'PE' },
  { title: 'PI - Piauí', value: 'PI' },
  { title: 'RJ - Rio de Janeiro', value: 'RJ' },
  { title: 'RN - Rio Grande do Norte', value: 'RN' },
  { title: 'RS - Rio Grande do Sul', value: 'RS' },
  { title: 'RO - Rondônia', value: 'RO' },
  { title: 'RR - Roraima', value: 'RR' },
  { title: 'SC - Santa Catarina', value: 'SC' },
  { title: 'SP - São Paulo', value: 'SP' },
  { title: 'SE - Sergipe', value: 'SE' },
  { title: 'TO - Tocantins', value: 'TO' },
]

export const nomeCampoOptions = [
  // { title: 'Cidade', value: 'cidade' },
  { title: 'Nome Fantasia', value: 'nomefantasia' },
  { title: 'Número da Revenda', value: 'nrevenda' },
  { title: 'Gestor da Conta', value: 'gestor' },
  { title: 'Razão Social', value: 'razao_social' },
]

export const selecionaOptions = [
  { title: 'Selecione', value: '' },
  { title: 'Sim', value: 's' },
  { title: 'Não', value: 'n' },
]

export const produtoOptions = [
  { title: 'Selecione', value: '' },
  { title: 'Gás', value: 'gas' },
  { title: 'Água', value: 'agua' },
]

export const useRevendasMapaStore = defineStore('revendasMapa', () => {
  const notificationStore = useNotificationStore()

  const today = (() => {
    const d = new Date()
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  })()

  /*
  {
    id:number,
    idrevendedor:number,
    status_tmkt:boolean,
    status_revendedor:boolean,
    status_revenda:boolean,
    campanha:any[],
    nomefantasia:string,
    ativo:boolean,
    polygons:{type:string, coordinates:Array<Array<number[]>>} 
  }[]
  */
  const revendas = ref([])

  /*
  {
    "lat_entrega": number;
    "motivocancel": string | null;
    "long_entrega": number;
    "idpedido": number;
    "status": string;
    "origem": number;
    "categoria_produto"?: 'GAS' | 'AGUA';
		}[]
  */
  const pedidos = ref([])

  // selectedRevenda para edição/salvamento de coordenadas no mapa
  /*
    exemplo:
    {
      idrevenda: 123,
      idrevendedor: 45,
      coordsJson: [
        [
          { lat: -23.55052, lng: -46.633308 },
          ...
        ],
      ]
    }
  */
  const selectedRevenda = ref(null)
  const selectedRevendaId = ref(null)

  /*
  {
    id:         number;
    latitude:   string;
    longitude:  string;
    origem:     number;
    rua:        string;
    numero:     string;
    tipo:       null;
    data:       Date;
    encontrado: 'S' | 'N';
    iconUrl:    string;
    origemLabel: string;
  }[]
  */
  const enderecosBuscados = ref([])
  const countBuscasSim = ref(0)
  const countBuscasNao = ref(0)

  const loading = ref({
    revendas: false,
    pedidos: false,
    enderecos: false,
    salvar: false,
  })

  // filtros iniciais com campos solicitados
  const filtros = ref({
    filtro_status_do_pedido: '',
    dtinicio: today,
    dtfinal: today,
    filtro_status_revendedor: '',
    filtro_status_revenda: '',
    filtro_status_ativado: '',
    filtro_estado: 'SP',
    filtro_cidade: 'São Paulo',
    nome_campo_filtro: 'nomefantasia',
    pesquisar: '',
    encontrado_filtro: '',
    campanha_filtro: '',
    aplicar_pedidos: false,
    aplicar_buscas_enderecos: false,
    reset_marker: false,
    filtro_produto: '',
  })

  const citiesList = ref(
    citiesByStates.estados
      .find((itemState) => itemState.sigla === 'SP')
      .cidades.map((c) => ({ title: c, value: c })) || [],
  )

  const showNotification = (message, type = 'success') => {
    notificationStore.showNotification(message, type)
  }

  const searchRevendas = async () => {
    try {
      if (loading.value.revendas) {
        return // evita chamadas concorrentes
      }

      loading.value = {
        ...loading.value,
        revendas: true,
      }

      const response = await useApi(REVENDAS_MAP.REVENDAS).fetch({
        params: {
          filtro_status_do_pedido: filtros.value.filtro_status_do_pedido,
          dtinicio: filtros.value.dtinicio,
          dtfinal: filtros.value.dtfinal,
          filtro_status_revendedor: filtros.value.filtro_status_revendedor,
          filtro_status_revenda: filtros.value.filtro_status_revenda,
          filtro_status_ativado: filtros.value.filtro_status_ativado,
          filtro_estado: filtros.value.filtro_estado,
          filtro_cidade: filtros.value.filtro_cidade,
          nome_campo_filtro: filtros.value.nome_campo_filtro,
          pesquisar: filtros.value.pesquisar,
          encontrado_filtro: filtros.value.encontrado_filtro,
          campanha_filtro: filtros.value.campanha_filtro,
          aplicar_pedidos: filtros.value.aplicar_pedidos ? '1' : null,
          aplicar_buscas_enderecos: filtros.value.aplicar_buscas_enderecos ? '1' : null,
          reset_marker: filtros.value.reset_marker ? '1' : null,
          filtro_produto: filtros.value.filtro_produto,
        },
      })

      // Monta revendas com polígonos extraídos de diferentes campos retornados pela API
      const revendasData = response.data?.length
        ? response.data.map((revenda) => {
            // coletar polígonos possíveis
            const polygonsArr = []

            // 1) Se existir campo "polygons" (string ou já objeto)
            if (revenda.polygons) {
              try {
                const parsed =
                  typeof revenda.polygons === 'string'
                    ? JSON.parse(revenda.polygons)
                    : revenda.polygons
                // normalize para array
                if (Array.isArray(parsed)) polygonsArr.push(...parsed)
                else polygonsArr.push(parsed)
              } catch {
                // ignora parse error
                console.warn('Erro parse revenda.polygons')
              }
            }

            // 2) Se existir revenda_coordenadas[].boundary_geojson (string GeoJSON)
            if (Array.isArray(revenda.revenda_coordenadas)) {
              revenda.revenda_coordenadas.forEach((rc) => {
                if (!rc) return
                const b =
                  rc.boundary_geojson || rc.boundary_geojson_string || rc.boundary_geojson_str
                if (!b) return
                try {
                  const parsed = typeof b === 'string' ? JSON.parse(b) : b
                  // parsed pode ser um GeoJSON Polygon/MultiPolygon ou um array
                  if (Array.isArray(parsed)) polygonsArr.push(...parsed)
                  else polygonsArr.push(parsed)
                } catch {
                  console.warn('Erro parse boundary_geojson')
                }
              })
            }

            // garante que sempre retorne um array (vazio se nada)
            return {
              id: revenda.id,
              idrevendedor: revenda.idrevendedor,
              nomefantasia: revenda.nomefantasia,
              ativo: revenda.ativo === '1' || revenda.ativo === 1,
              status_tmkt: !!Number(revenda.status_tmkt),
              status_revendedor: !!Number(revenda.status_revendedor),
              status_revenda: !!Number(revenda.status_revenda),
              campanha: revenda.campanha || [],
              polygons: polygonsArr,
            }
          })
        : []

      revendas.value = revendasData || []

      return revendasData
    } catch (error) {
      console.error('Erro ao buscar revendas')
    } finally {
      loading.value = {
        ...loading.value,
        revendas: false,
      }
    }
  }

  const searchPedidos = async () => {
    try {
      if (loading.value.pedidos) {
        return // evita chamadas concorrentes
      }

      if (!verifyIfDateRangeIsValid(filtros.value.dtinicio, filtros.value.dtfinal)) {
        showNotification('O período entre as datas não pode ser maior que 31 dias.', 'warning')
        return
      }

      loading.value = {
        ...loading.value,
        pedidos: true,
      }

      const response = await useApi(REVENDAS_MAP.PEDIDOS).fetch({
        params: {
          pesquisar: filtros.value.pesquisar,
          nome_campo_filtro: filtros.value.nome_campo_filtro,
          filtro_estado: filtros.value.filtro_estado,
          filtro_cidade: filtros.value.filtro_cidade,
          dtinicio: filtros.value.dtinicio,
          dtfinal: filtros.value.dtfinal,
          filtro_status_do_pedido: filtros.value.filtro_status_do_pedido,
          aplicar_pedidos: filtros.value.aplicar_pedidos ? 1 : null,
          filtro_produto: filtros.value.filtro_produto,
        },
      })

      pedidos.value = response.data?.length ? response.data : []
    } catch (error) {
      console.error('Erro ao buscar pedidos')
    } finally {
      loading.value = {
        ...loading.value,
        pedidos: false,
      }
    }
  }

  const resolveLogIconEnderecos = (result) => {
    const encontrado = String(result.encontrado ?? '').toUpperCase()
    const origemKey = String(result.origem ?? '')

    // procura por match no "encontrado" (S/N) primeiro
    let entry = statusIconColorsEnderecos.find((e) => String(e.value) === encontrado)

    // se não encontrou por encontrado, tenta por origem
    if (!entry) entry = statusIconColorsEnderecos.find((e) => String(e.value) === origemKey)

    // fallback: green
    if (!entry) entry = statusIconColorsEnderecos.find((e) => e.value === '1')

    // atualiza contadores
    if (encontrado === 'S') countBuscasSim.value++
    else if (encontrado === 'N') countBuscasNao.value++

    // monta label de origem
    let origemLabel = 'APP'
    switch (origemKey) {
      case '1':
        origemLabel = 'TMKT'
        break
      case '2':
        origemLabel = 'Preço do Gás'
        break
      case '16':
        origemLabel = 'APP Novo'
        break
      case '17':
        origemLabel = 'APP Apple'
        break
      default:
        origemLabel = 'APP'
        break
    }

    const iconUrl = entry.link

    return { iconUrl, origemLabel }
  }

  const searchEnderecos = async () => {
    try {
      if (loading.value.enderecos) {
        return // evita chamadas concorrentes
      }

      if (!verifyIfDateRangeIsValid(filtros.value.dtinicio, filtros.value.dtfinal)) {
        showNotification('O período entre as datas não pode ser maior que 31 dias.', 'warning')
        return
      }

      loading.value = {
        ...loading.value,
        enderecos: true,
      }

      const response = await useApi(REVENDAS_MAP.BUSCAR_ENDERECOS).fetch({
        params: {
          pesquisar: filtros.value.pesquisar,
          nome_campo_filtro: filtros.value.nome_campo_filtro,
          filtro_estado: filtros.value.filtro_estado,
          filtro_cidade: filtros.value.filtro_cidade,
          dtinicio: filtros.value.dtinicio,
          dtfinal: filtros.value.dtfinal,
          encontrado_filtro: filtros.value.encontrado_filtro,
          aplicar_buscas_enderecos: filtros.value.aplicar_buscas_enderecos ? 1 : null,
        },
      })

      enderecosBuscados.value = response.data?.length
        ? response.data.map((item) => ({
            ...item,
            ...resolveLogIconEnderecos(item),
          }))
        : []
    } catch (error) {
      console.error('Erro ao buscar endereços')
    } finally {
      loading.value = {
        ...loading.value,
        enderecos: false,
      }
    }
  }

  const verifyIfCoordsJsonIsNecessaryFormat = (coordsJson = []) => {
    return coordsJson[0]?.type === 'Polygon'
  }

  // salvar coordenadas (POST para REVENDAS_MAP.SAVE_COORDS)
  const handleSave = async () => {
    if (!selectedRevenda.value || !selectedRevenda.value.idrevenda) {
      showNotification('Nenhuma revenda selecionada para salvar', 'warning')
      return
    }

    try {
      loading.value = { ...loading.value, salvar: true }

      const isValidFormat = !verifyIfCoordsJsonIsNecessaryFormat(selectedRevenda.value.coordsJson)

      let coordsJson = isValidFormat ? selectedRevenda.value.coordsJson || [] : []

      if (!isValidFormat) {
        try {
          const original = selectedRevenda.value.coordsJson || []
          const transformed = []

          original.forEach((item) => {
            if (!item) return

            const type = item.type
            const coords = item.coordinates || item

            if (type === 'Polygon') {
              // coords: [ [ [lat, lng], ... ], ... ] -> push each ring as an array of {lat,lng}
              coords.forEach((ring) => {
                if (!Array.isArray(ring)) return
                transformed.push(
                  ring.map((pair) => ({
                    lat: Number(pair[0]),
                    lng: Number(pair[1]),
                  })),
                )
              })
            } else if (type === 'MultiPolygon') {
              // coords: [ [ [ [lat, lng], ... ], ... ], ... ]
              coords.forEach((polygon) => {
                polygon.forEach((ring) => {
                  if (!Array.isArray(ring)) return
                  transformed.push(
                    ring.map((pair) => ({
                      lat: Number(pair[0]),
                      lng: Number(pair[1]),
                    })),
                  )
                })
              })
            } else if (Array.isArray(coords)) {
              // fallback for arrays of rings or arrays of points
              // coords could be [ [ [lat,lng], ... ], ... ] or [ [lat,lng], ... ]
              if (Array.isArray(coords[0]) && Array.isArray(coords[0][0])) {
                // array of rings
                coords.forEach((ring) => {
                  transformed.push(
                    ring.map((pair) => ({
                      lat: Number(pair[0]),
                      lng: Number(pair[1]),
                    })),
                  )
                })
              } else {
                // single ring (array of points)
                transformed.push(
                  coords.map((pair) => ({
                    lat: Number(pair[0]),
                    lng: Number(pair[1]),
                  })),
                )
              }
            }
          })

          coordsJson = transformed
        } catch {
          console.warn('Erro ao transformar coordsJson:')
          coordsJson = []
        }
      }

      const payload = {
        idrevenda: selectedRevenda.value.idrevenda,
        idrevendedor: selectedRevenda.value.idrevendedor || null,
        coordsJson: coordsJson,
      }

      // Usa fetch com method POST — utilitário useApi aceita opções
      const response = await useApi(REVENDAS_MAP.SAVE_COORDS).post(payload)

      // adaptar conforme retorno da API
      if (response?.status === 'success' || response?.status === 200) {
        showNotification(response.message || 'Coordenadas salvas com sucesso', 'success')
        return response.data
      } else {
        showNotification(response.message || 'Erro ao salvar coordenadas', 'error')
        return response.data
      }
    } catch {
      console.error('Erro ao salvar coords:')
      showNotification('Erro ao salvar coordenadas', 'error')
    } finally {
      loading.value = { ...loading.value, salvar: false }
    }
  }

  const clearFilters = () => {
    filtros.value = {
      filtro_status_do_pedido: '',
      dtinicio: today,
      dtfinal: today,
      filtro_status_revendedor: '',
      filtro_status_revenda: '',
      filtro_status_ativado: '',
      filtro_estado: 'SP',
      filtro_cidade: 'São Paulo',
      nome_campo_filtro: 'nomefantasia',
      pesquisar: '',
      encontrado_filtro: '',
      campanha_filtro: '',
      aplicar_pedidos: false,
      aplicar_buscas_enderecos: false,
      reset_marker: false,
      filtro_produto: '',
    }
    selectedRevendaId.value = null
    selectedRevenda.value = null
  }

  // novo alias para compatibilidade com a view (revendasMapaStore.resetFiltros())
  const resetFiltros = () => clearFilters()

  watch(
    () => filtros.value.filtro_estado,
    (newEstado) => {
      const stateObj = citiesByStates.estados.find((itemState) => itemState.sigla === newEstado)

      citiesList.value = stateObj?.cidades?.length
        ? stateObj.cidades.map((c) => ({ title: c, value: c }))
        : []

      filtros.value.filtro_cidade = '' // limpa cidade ao mudar estado
    },
  )

  const verifyIfDateRangeIsValid = (dtinicio, dtfinal) => {
    // caso seja a quantidade de dias seja maior que 31, mostra alerta
    const dateStart = new Date(dtinicio)
    const dateEnd = new Date(dtfinal)
    const diffTime = Math.abs(dateEnd - dateStart)
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    if (diffDays > 31) {
      return false
    }

    return true
  }

  watch(
    () => [filtros.value.dtinicio, filtros.value.dtfinal],
    ([newDtInicio, newDtFinal]) => {
      // garante que dtinicio nunca seja maior que dtfinal
      if (newDtInicio && newDtFinal) {
        if (newDtInicio > newDtFinal) {
          // ajusta dtfinal para ser igual a dtinicio
          filtros.value.dtfinal = newDtInicio
        }

        if (!verifyIfDateRangeIsValid(newDtInicio, newDtFinal)) {
          showNotification('O período entre as datas não pode ser maior que 31 dias.', 'warning')
        }
      }
    },
  )

  watch(
    () => selectedRevendaId.value,
    (newIdRevenda) => {
      if (!newIdRevenda) {
        selectedRevenda.value = null
        return
      }

      // busca a revenda selecionada na lista de revendas
      const revendaEncontrada = revendas.value.find((r) => Number(r.id) === Number(newIdRevenda))

      if (revendaEncontrada) {
        selectedRevenda.value = {
          idrevenda: revendaEncontrada.id,
          idrevendedor: revendaEncontrada.idrevendedor,
          coordsJson: revendaEncontrada.polygons || [],
        }
      } else {
        selectedRevenda.value = null
      }
    },
  )

  return {
    filtros,
    loading,
    revendas,
    pedidos,
    enderecosBuscados,
    citiesList,
    selectedRevenda,
    selectedRevendaId,
    countBuscasSim,
    countBuscasNao,
    searchRevendas,
    searchPedidos,
    searchEnderecos,
    handleSave,
    clearFilters,
    resetFiltros,
    showNotification,
  }
})
